import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { Box } from '@mui/material';
import ButtonComponent from '../../../components/ButtonComponent';
import { Add, Phone } from '@mui/icons-material';
import React, { useContext, useEffect, useState } from 'react';
import DeviceLinkWithSipClientEditionModal from './DeviceLinkWithSipClientEditionModal';
import {
  useDeleteSipClientLinkedDeviceAsync,
  useGetAllSipClientLinkedDeviceByLicenseCountAsync,
  useGetSipClientLinkedDeviceByIdAsync,
} from '../../../services/SipClientLinkedDeviceService/hooks/useMutation';
import { ISipClientLinkedDeviceProps } from '../../../services/SipClientLinkedDeviceService/types';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import ConfirmDeleteModalComponent from '../../../components/ConfirmDeleteModalComponent';
import { AppContext } from '../../../context/AppContextProvider';
import IsOnlineComponent from '../../../components/IsOnlineComponent';
import { IPaginationParams } from '../../../services/types';
import { getStreamByEndpointAsync } from '../../../services/Events';
import { ENDPOINT_SIP_CLIENT_LINKED_DEVICE } from '../../../services/SipClientLinkedDeviceService';

interface IDeviceLinkWithSipClientProps {
  onCallAsync: (phoneNumber?: string) => void;
}

const DeviceLinkWithSipClient = ({
  onCallAsync,
}: IDeviceLinkWithSipClientProps) => {
  const [isVisibleDeviceLinkModal, setIsVisibleDeviceLinkModal] =
    useState(false);
  const { showSnackbar } = useContext(AppContext);
  const [sipClientLinkedDevice, setSipClientLinkedDevice] = useState<
    ISipClientLinkedDeviceProps[]
  >([]);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [count, setCount] = useState<number>(0);
  const [sipClientLinkedDeviceSelected, setSipClientLinkedDeviceSelected] =
    useState<ISipClientLinkedDeviceProps>();
  const [selectedItemToDelete, setSelectedItemToDelete] = useState<
    ISipClientLinkedDeviceProps | undefined
  >();
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);

  const { mutateAsync: mutateGetAllSipClientLinkedDeviceByLicenseCountAsync } =
    useGetAllSipClientLinkedDeviceByLicenseCountAsync();
  const { mutateAsync: mutateGetSipClientLinkedDeviceByIdAsync } =
    useGetSipClientLinkedDeviceByIdAsync();
  const { mutateAsync: mutateDeleteSipClientLinkedDeviceAsync } =
    useDeleteSipClientLinkedDeviceAsync();

  const columns: IColumnProps[] = [
    { label: 'Ramal', id: 'name' },
    {
      label: 'Dispositivo vinculado',
      id: 'id',
      render: (sipClientLinkedDeviceId) => {
        let render = <></>;
        const sipClientLinked = sipClientLinkedDevice.find(
          (sl) => sl.id == Number(sipClientLinkedDeviceId),
        );

        if (sipClientLinked) {
          render = (
            <Box display={'flex'} columnGap={1}>
              <IsOnlineComponent
                isOnline={sipClientLinked.device.isOnline}
                width={18}
                height={18}
              />
              {sipClientLinked.device.name}
            </Box>
          );
        }
        return render;
      },
    },
    {
      label: '',
      id: 'name',
      width: 0,
      render: (ramal) => {
        return (
          <ButtonComponent
            startIcon={<Phone />}
            size={'small'}
            variant={'outlined'}
            onClick={() => onCallAsync(ramal)}
          >
            Ligar
          </ButtonComponent>
        );
      },
    },
    {
      label: 'Ações',
      width: '0%',
      id: 'id',
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDelete(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleEdit = async (id: number) => {
    await mutateGetSipClientLinkedDeviceByIdAsync(id).then(
      setSipClientLinkedDeviceSelected,
    );
    setIsVisibleDeviceLinkModal(true);
  };

  const handleDelete = async (id: number) => {
    setSelectedItemToDelete(sipClientLinkedDevice?.find((i) => i.id === id));
    setIsVisibleDeleteModal(true);
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteModal(false);
    setSipClientLinkedDeviceSelected(undefined);
  };

  const handleConfirmDeletion = async () => {
    if (selectedItemToDelete?.id) {
      await mutateDeleteSipClientLinkedDeviceAsync(selectedItemToDelete?.id, {
        onSuccess: (_) => {
          showSnackbar('Ramal excluído com sucesso.', 'success');
        },
      });
      setSelectedItemToDelete(undefined);
      setIsVisibleDeleteModal(false);
    }
  };

  // const getSipClientLinkedDevices = () => {
  //   mutateGetAllSipClientLinkedDeviceByLicenseAsync().then(
  //     setSipClientLinkedDevice,
  //   );
  // };

  // useEffect(() => {
  //   getSipClientLinkedDevices();
  // }, []);

  const getSipClientLinkedDevices = (pagination: IPaginationParams) => {
    getStreamByEndpointAsync(
      ENDPOINT_SIP_CLIENT_LINKED_DEVICE,
      setSipClientLinkedDevice,
      pagination,
      undefined,
      undefined,
      undefined,
      true,
    );
    mutateGetAllSipClientLinkedDeviceByLicenseCountAsync().then(setCount);
  };

  useEffect(() => {
    getSipClientLinkedDevices(pagination);
  }, [pagination]);
  return (
    <>
      <TableComponent
        rows={sipClientLinkedDevice}
        columns={columns}
        title={'Ramais vinculados a dispositivos'}
        isLoading={false}
        totalCount={count}
        onChangePageOrRowsPerPage={setPagination}
        additionalTitleComponent={
          <Box gap={2} display={'flex'}>
            <ButtonComponent
              size={'small'}
              startIcon={<Add />}
              onClick={() => setIsVisibleDeviceLinkModal(true)}
            >
              Novo vínculo
            </ButtonComponent>
          </Box>
        }
      />

      <ConfirmDeleteModalComponent
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
        isVisibleDeleteDialog={isVisibleDeleteModal}
        message={`Tem certeza que deseja deletar o vínculo ${selectedItemToDelete?.name}?`}
        setIsVisibleDeleteDialog={setIsVisibleDeleteModal}
        title={'Deletar Ramal'}
      />

      <DeviceLinkWithSipClientEditionModal
        isVisible={isVisibleDeviceLinkModal}
        sipClientSelected={sipClientLinkedDeviceSelected}
        onClose={() => {
          setIsVisibleDeviceLinkModal(false);
        }}
      />
    </>
  );
};

export default DeviceLinkWithSipClient;
